import { render, staticRenderFns } from "./HcpcReport.vue?vue&type=template&id=2f631c79"
import script from "./HcpcReport.vue?vue&type=script&lang=js"
export * from "./HcpcReport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports